import SEO from "../components/site/SEO";
import Hero from "../components/home/Hero";
import HolidaysBanner from "../components/home/HolidaysBanner";
import Experiences from "../components/home/Experiences";
import NonRider from "../components/home/NonRider";
import WhyUs from "../components/home/WhyUs";
import Featured from "../components/home/Featured";
import ApuseniSection from "../components/home/ApuseniSection";
import Gallery from "../components/home/Gallery";
import Rentals from "../components/home/Rentals";
import PickupLocations from "../components/home/PickupLocations";
import FinalCTA from "../components/home/FinalCTA";

export default function Home() {
  return (
    <div data-testid="home-page">
      <SEO titleKey="home.title" descKey="home.description" path="/" />
      <Hero />
      <HolidaysBanner />
      <Experiences />
      <NonRider />
      <WhyUs />
      <Featured />
      <ApuseniSection />
      <Gallery />
      <Rentals />
      <PickupLocations />
      <FinalCTA />
    </div>
  );
}
